import { cva } from 'class-variance-authority';

/**
 * Base notification styles applied to all notification variants.
 */
export const baseNotificationStyles = [
  'bg-neutral-white',
  'border-neutral-gray-500',
  'border-solid',
  'border',
  'max-w-md',
  'p-4',
  'relative',
  'rounded-lg',
  'text-sm',
  'w-full',
].join(' ');

/**
 * Notification variants using class-variance-authority.
 * Can be extended for different notification types (info, warning, error, etc.)
 */
export const notificationVariants = cva(baseNotificationStyles, {
  variants: {
    variant: {
      // Default notification variant
      default: [],
      
      // Can add more variants like success, warning, error in the future
      info: ['border-blue-400'],
      success: ['border-green-400'],
      warning: ['border-yellow-400'],
      error: ['border-red-400'],
    },
  },

  // Default notification variant
  defaultVariants: {
    variant: 'default',
  },
});

/**
 * Button styles for notification actions
 */
export const notificationButtonVariants = cva([
  'inline-flex',
  'items-center',
  'justify-center',
  'rounded-full',
  'px-5',
  'py-2',
  'text-sm',
  'font-bold',
  'leading-7',
  'whitespace-nowrap',
  'transition-colors',
  'duration-200',
  'ease-in-out',
  'h-8',
].join(' '), {
  variants: {
    variant: {
      // Primary action button - filled
      primary: [
        'bg-brand-primary',
        'text-neutral-white',
        'hover:bg-brand-primary-600',
        'active:bg-brand-primary-700',
        'focus-visible:bg-brand-primary-700',
        'focus-visible:outline-1',
        'focus-visible:outline-brand-primary-700',
        'focus-visible:outline-dashed',
        'focus-visible:outline-offset-2',
      ],

      // Secondary action button - outline
      secondary: [
        'bg-transparent',
        'text-brand-primary',
        'border-2',
        'border-brand-primary',
        'hover:text-brand-primary-600',
        'hover:border-brand-primary-600',
        'active:text-brand-primary-700',
        'active:border-brand-primary-700',
        'focus-visible:text-brand-primary-700',
        'focus-visible:border-brand-primary-700',
        'focus-visible:outline-1',
        'focus-visible:outline-brand-primary-700',
        'focus-visible:outline-dashed',
        'focus-visible:outline-offset-2',
      ],
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

/**
 * Close button styles
 */
export const closeButtonStyles = [
  'border-transparent',
  'border',
  'duration-200',
  'ease-in-out',
  'focus-visible:border-transparent',
  'focus-visible:outline-1',
  'focus-visible:outline-brand-primary-700',
  'focus-visible:outline-dashed',
  'focus-visible:outline-offset-2',
  'focus-visible:text-brand-primary-700',
  'hover:border-brand-primary',
  'hover:text-brand-primary',
  'inline-flex',
  'items-center',
  'justify-center',
  'p-1',
  'rounded-full',
  'shrink-0',
  'transition-colors',
].join(' ');